import { Redirect, Route } from 'react-router-dom'

import React from 'react'

function ProtectedRoute({ children, component: Component, ...rest }) {
  const user = sessionStorage.getItem(process.env.REACT_APP_API_LOCAL_STORAGE)
  return user
    ? (<Route {...rest} component={Component} />)
    : (<Redirect to={'/login'} />)
}

export default ProtectedRoute